<div class="container-fluid mt-3">
<!--  <prettyjson [obj]="counsellorReviewForm.value"></prettyjson>-->
  <h2 class="text-center mb-3">{{ currentEditId ? 'Update Counselling Observation':'Add Counselling Observation' }}</h2>
  <form [formGroup]="counsellorReviewForm" class="row" autocomplete="off">
<!--    <app-searchable-select class="col-md-4"-->
<!--      [options]="counselorName"-->
<!--      displayKey="name"-->
<!--      placeholder="Select Counsellor Name"-->
<!--      label="Select Counsellor Name"-->
<!--                           [selectedValue]="{ name: counsellorReviewForm.get('counsellorName')?.value }"-->
<!--      (selectionChange)="onCounselorSelected($event)"-->
<!--    ></app-searchable-select>-->

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="counselorName"
                           displayKey="name"
                           placeholder="Select Counsellor Name"
                           label="Select Counsellor Name"
                           [selectedValue]="{ name: counsellorReviewForm.get('counsellor')?.value }"
                           (selectionChange)="onCounselorSelected($event)"
    ></app-searchable-select>


    <!-- Session Date -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Session Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="sessionDate" placeholder="Select date" [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Observed By -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Observed By</mat-label>
        <mat-select formControlName="observedBy">
          <mat-option *ngFor="let o of observers" [value]="o">{{ o }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Counselling Skills -->
    <div class="col-md-3 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Counselling Skills</mat-label>
        <mat-select formControlName="counsellingSkills">
          <mat-option *ngFor="let r of ratings" [value]="r.value">{{ r.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Interventions -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Interventions</mat-label>
        <mat-select formControlName="interventions">
          <mat-option *ngFor="let r of ratings" [value]="r.value">{{ r.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Understanding of core problem -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Understanding of Core Problem</mat-label>
        <mat-select formControlName="understandingOfProblem">
          <mat-option *ngFor="let r of ratings" [value]="r.value">{{ r.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Home Program -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Home Program</mat-label>
        <mat-select formControlName="homeProgram">
          <mat-option *ngFor="let r of ratings" [value]="r.value">{{ r.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Feedback -->
    <div class="col-md-12 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Feedback</mat-label>
        <textarea matInput maxlength="500" rows="3" formControlName="feedback" placeholder="Enter feedback"></textarea>
        <mat-hint align="end">
          {{ remarkLength }} / 500
        </mat-hint>
      </mat-form-field>
    </div>

    <!-- Submit Button -->
    <div class="col-12 justify-content-center d-flex gap-2">
      <button mat-raised-button color="warn" (click)="mDialogRef.close()" >Cancel</button>
      <button mat-raised-button color="primary" [disabled]="counsellorReviewForm.invalid || isLoading" (click)="submitForm()">{{ currentEditId ? 'Update ':'Submit' }}</button>
    </div>

  </form>
</div>

<!-- Loader Spinner (only visible while loading) -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
